// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bisharp: PokeData = {
  "id": 625,
  "name": "bisharp",
  "height": 16,
  "weight": 700,
  "base_experience": 172,
  "types": [
    PokeType.DARK,
    PokeType.STEEL
  ],
  "api_moves": [
    "scratch",
    "guillotine",
    "swords-dance",
    "leer",
    "slash",
    "scary-face",
    "feint-attack",
    "fury-cutter",
    "metal-claw",
    "torment",
    "metal-sound",
    "iron-defense",
    "metal-burst",
    "assurance",
    "embargo",
    "night-slash",
    "iron-head",
    "retaliate",
    "laser-focus"
  ],
  "moves": [
    "scratch",
    "leer",
    "scary-face",
    "metal-claw",
    "metal-sound",
    "iron-defense",
    "metal-burst",
    "night-slash",
    "pursuit",
    "lash-out",
    "metal-rush",
    "snarl",
    "bite"
  ],
  "evolution_chain": {
    "id": 317,
    "item": null,
    "species": [
      {
        "name": "pawniard",
        "order": 625,
        "types": [
          PokeType.DARK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bisharp",
        "order": 626,
        "types": [
          PokeType.DARK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 624,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 52,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "kingambit",
        "order": 1008,
        "types": [
          PokeType.DARK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 625,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 75,
    "speed": 70,
    "ability_power": 125
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
